
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/[page]",
      function () {
        return require("private-next-pages/press/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press/[page]"])
      });
    }
  